import { createStore, createLogger } from 'vuex';
import app from './modules/app';
import sale from './modules/sale';

const options = {
    modules: {
        app,
        sale,
    },
    plugins: [],
};

if (process.env.NODE_ENV !== 'production') {
    options.plugins.push(createLogger());
}

export default createStore(options);
